import type { Estimate } from '@/shared/api/types';
import { formatTime } from '@/shared/format/dates';
import { formatConfidence, formatEstimateKcal, sourceLabel } from '@/shared/format/nutrition';
import { Card, Eyebrow } from '@/shared/ui';

/**
 * RF-22 · el historial de estimaciones.
 *
 * Ninguna estimación se borra: cada una queda con la versión del motor que la produjo. Esto no es
 * una curiosidad de auditoría — es lo que permite entender por qué el número cambió y confiar en
 * que no cambia solo.
 */
export function EstimateHistory({ estimates }: { estimates: Estimate[] }) {
  if (estimates.length === 0) {
    return null;
  }

  return (
    <Card>
      <Eyebrow>Historial de estimaciones</Eyebrow>

      <ul className="list-reset" style={{ gap: 'var(--space-2)' }}>
        {estimates.map((estimate) => (
          <li key={estimate.id} className="history-row">
            <span
              className={estimate.isCurrent ? 'history-dot history-dot-current' : 'history-dot'}
            />
            <span style={{ flex: 1 }}>
              {sourceLabel(estimate.source)} · {formatConfidence(estimate.confidence)}
            </span>
            <span className={estimate.isCurrent ? '' : 'muted'}>
              {formatEstimateKcal(estimate)} kcal
            </span>
            <span className="muted">{formatTime(estimate.generatedAt)}</span>
          </li>
        ))}
      </ul>

      <p className="micro muted">
        Nada se borra: cada estimación queda con la versión del motor que la produjo.
      </p>
    </Card>
  );
}
